import React, {useState} from 'react';
import SimpleImageCarousel from '@homeaway/react-simple-image-carousel';
import {SVGDefinitions, SVGIcon} from '@homeaway/react-svg';

export const CarouselIconDefinitions = () => (
    <SVGDefinitions>
        <symbol id="SVG_SERP_CHEVRON_LEFT__24">
            <svg
                data-id="SVG_SERP_CHEVRON_LEFT__24"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 23L5 12 16 1"
                />
            </svg>
        </symbol>
        <symbol id="SVG_SERP_CHEVRON_RIGHT__24">
            <svg
                data-id="SVG_SERP_CHEVRON_RIGHT__24"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8 23l11-11L8 1"
                />
            </svg>
        </symbol>
    </SVGDefinitions>
);

const convertImagesIntoSimpleCarouselFormat = (imagesArray) => {
    return imagesArray
        .filter((listingImage) => !!listingImage)
        .map((listingImage) => ({
            src: listingImage.c6_uri || listingImage.uri,
            altText: listingImage.altText || '',
        }));
};

const Carousel = ({infoWindowOptions, onImageClick, localizedUrl}) => {
    let {images, navigationCallBack} = infoWindowOptions;

    const slideImages = convertImagesIntoSimpleCarouselFormat(images);
    const [imageIndex, setImageIndex] = useState(0);
    const navigateToListing = () => {
        if (typeof onImageClick === 'function') {
            onImageClick();
        }
        if (window) {
            window.open(localizedUrl, '_blank');
        }
    };

    const onImageNavigate = (index) => {
        let previousIndex = imageIndex;
        setImageIndex(index);
        if (typeof navigationCallBack === 'function') {
            navigationCallBack({
                imageSrc: slideImages[index].src,
                index,
                previousIndex,
            });
        }
    };

    return (
        <SimpleImageCarousel
            images={slideImages}
            index={imageIndex}
            transitionStyle="slide"
            transitionDuration={250}
            onNextClick={onImageNavigate}
            onPrevClick={onImageNavigate}
            onClick={navigateToListing}
            tabIndex={-1}
            renderButtons={({setPrevRef, setNextRef}) => {
                return [
                    <button
                        key="0"
                        className="SimpleImageCarousel__button SimpleImageCarousel__button--left"
                        data-wdio="SimpleImageCarousel__button--prev"
                        ref={setPrevRef}
                        tabIndex="-1"
                    >
                        <span className="sr-only">{'Previous Image'}</span>
                        <SVGIcon
                            className="SimpleImageCarousel__svg SimpleImageCarousel__svg--right"
                            id="SERP_CHEVRON_LEFT__24"
                        />
                    </button>,
                    <button
                        key="1"
                        className="SimpleImageCarousel__button SimpleImageCarousel__button--right"
                        data-wdio="SimpleImageCarousel__button--next"
                        ref={setNextRef}
                        tabIndex="-1"
                    >
                        <span className="sr-only">{'Next Image'}</span>
                        <SVGIcon
                            className="SimpleImageCarousel__svg SimpleImageCarousel__svg--right"
                            id="SERP_CHEVRON_RIGHT__24"
                        />
                    </button>,
                ];
            }}
        />
    );
};

export {Carousel, convertImagesIntoSimpleCarouselFormat};
